/* eslint-disable max-len */
import { getCache } from 'core/cache';

import without from 'lodash/without';
import cloneDeep from 'lodash/cloneDeep';

const handleShouldPreventCollapseToggle = ({ expandedIdsCacheKey, cacheKey, itemId }) => {
  const expandedItemIds = getCache(expandedIdsCacheKey);

  let updatedItemIds = expandedItemIds.data;

  const isExpanded = expandedItemIds.data.includes(itemId);

  if (isExpanded) return;

  updatedItemIds = [...expandedItemIds.data, itemId];

  expandedItemIds.set(updatedItemIds);

  const orderedItems = getCache(cacheKey);
  const updatedOrderedItems = cloneDeep(orderedItems.data);

  const item = updatedOrderedItems.items[itemId];
  item.isExpanded = true;

  orderedItems.set(updatedOrderedItems);
};

const getPostCollapseUpdatedItemIds = ({ expandedItemIds, itemId, children }) => {
  const idsToExclude = [itemId, ...children];
  return without(expandedItemIds.data, ...idsToExclude);
};

export default ({
  expandedIdsCacheKey, cacheKey, itemId, children, shouldPreventCollapse = false,
}) => {
  const expandedItemIds = getCache(expandedIdsCacheKey);

  let updatedItemIds = expandedItemIds.data;

  const isExpanded = expandedItemIds.data.includes(itemId);

  if (shouldPreventCollapse) {
    handleShouldPreventCollapseToggle({ itemId });
  } else {
    if (isExpanded) {
      updatedItemIds = getPostCollapseUpdatedItemIds({ expandedItemIds: expandedItemIds.data, itemId, children });
    } else {
      updatedItemIds = [...expandedItemIds.data, itemId];
    }

    expandedItemIds.set(updatedItemIds);

    const orderedItems = getCache(cacheKey);
    const updatedOrderedItems = cloneDeep(orderedItems.data);

    const item = updatedOrderedItems.items[itemId];
    item.isExpanded = !item.isExpanded;

    if (children.length && isExpanded) {
      children.forEach((childId) => {
        const childItem = updatedOrderedItems.items[childId];
        childItem.isExpanded = false;
      });
    }

    orderedItems.set(updatedOrderedItems);
  }
};
